/**
 * Formats a sell-to-list ratio as a percentage string.
 * Handles both fractional (0.98) and already-percentage (98.x) representations.
 *
 * @example
 * formatRatio(0.98) // "98.0%"
 * formatRatio(98.5) // "98.5%"
 */
export function formatRatio(ratio: number): string {
  const pct = ratio > 2 ? ratio : ratio * 100;
  return `${pct.toFixed(1)}%`;
}
